/**
 * Replaces a broken product icon with a neutral placeholder, mirroring the
 * former React ProductCard leaf fallback. No-op when the page has no product
 * cards, so it is safe to run on every Cropwise Accounts page.
 */
const applyIconFallback = (img) => {
  img.removeAttribute('src');
  img.parentElement?.classList.add('image--fallback');
};

export const initProductCardIcons = () => {
  for (const img of document.querySelectorAll('.product-card-container img')) {
    // The listener alone misses icons that failed before init (error won't
    // re-fire); the immediate check alone misses icons whose src Cookiebot's
    // auto-blocking restores after init. A src-less image hasn't failed yet.
    img.addEventListener('error', () => applyIconFallback(img), { once: true });
    if (img.getAttribute('src') && img.complete && img.naturalWidth === 0) {
      applyIconFallback(img);
    }
  }
};
